import { Checkbox, Code, Group, Stack, Text } from '@mantine/core'
import { IconCast } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { NormalizedStreamBusinessLogic } from '@/types/businessLogic'

const RTSP_URL = 'rtsp://<device_ip>:8552/live_detections'

type LiveOutputConfigProps = {
  liveOutput: NormalizedStreamBusinessLogic['live_output']
  onChange: (liveOutput: NormalizedStreamBusinessLogic['live_output']) => void
}

export const LiveOutputConfig = ({
  liveOutput,
  onChange
}: LiveOutputConfigProps) => {
  return (
    <Stack gap="xs">
      <Group wrap="nowrap" align="center" gap="xs">
        <Text size="sm" fw={600}>
          <FormattedMessage id="logic.liveOutput.title" />
        </Text>

        <IconCast size={18} />
      </Group>

      <Checkbox
        checked={liveOutput.screen}
        label={<FormattedMessage id="logic.liveOutput.screen.label" />}
        size="xs"
        description={
          <FormattedMessage
            id="logic.liveOutput.screen.description"
            values={{
              command: <Code fz={10}>sudo xhost +</Code>
            }}
          />
        }
        onChange={(event) =>
          onChange({
            ...liveOutput,
            screen: event.currentTarget.checked
          })
        }
      />

      <Checkbox
        checked={liveOutput.rtsp}
        label={<FormattedMessage id="logic.liveOutput.rtsp.label" />}
        size="xs"
        description={
          <FormattedMessage
            id="logic.liveOutput.rtsp.description"
            values={{
              rtspUrl: <Code fz={10}>{RTSP_URL}</Code>
            }}
          />
        }
        onChange={(event) =>
          onChange({
            ...liveOutput,
            rtsp: event.currentTarget.checked
          })
        }
      />

      {(liveOutput.screen || liveOutput.rtsp) && (
        <Text size="xs" c="dimmed">
          <FormattedMessage id="logic.liveOutput.ownContainer" />
        </Text>
      )}
    </Stack>
  )
}
